import Typed from 'typed.js';

function initTypedJS() {
	[... document.querySelectorAll('[data-vg-toggle="typed"]')].forEach(elm => {
		let text = elm.dataset?.text.trim();

		new Typed('#' + elm.id, {
			strings: [text],
			typeSpeed: 50,
			backSpeed: 0,
			fadeOut: true,
			loop: false,
			onComplete: function (self) {
				self.el.nextElementSibling.remove()
			}
		});
	})
}

export default initTypedJS;
